import { Module } from "wrapper6";
import Swiper from 'swiper/swiper-bundle'

export default class SwiperSlides extends Module {
	ready(app) {
        /* mtt-banner-slider */
        this.initSliders('.mtt-cta-image-banner--slider', {
            loop: true
        })

        /* mtt-slider-row */
        this.initSliders('.mtt-slider-row', {
            loop: true,
            slidesPerView: 2,
            spaceBetween: 16,
            breakpoints: {
                580: { slidesPerView: 3 },
                900: { slidesPerView: 2 },
                1160: { slidesPerView: 3 }
            }
        })

        /* mtt-slider-grid */
        this.initSliders('.mtt-slider-grid', {
            loop: true
        })
    }

    /* Helper methods for settings */
    getAutoplayDuration (sliderWrapper) {
        const autoplayAttribute = sliderWrapper.getAttribute('data-autoplay-duration')

        if (autoplayAttribute) {
            return { delay: parseInt(autoplayAttribute) }
        }

        return false
    }

    getPagination (sliderWrapper) {
        const paginationElement = sliderWrapper.querySelector('.swiper-pagination')

        if (paginationElement) {
            return {
                el: paginationElement,
                clickable: true
            }
        }

        return false
    }

    getArrows (sliderWrapper) {
        const arrowNext = sliderWrapper.querySelector('.swiper-button-next')
        const arrowPrev = sliderWrapper.querySelector('.swiper-button-prev')

        if (arrowNext && arrowPrev) {
            return {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            }
        }

        return false
    }

    /* Method to initialize sliders */
    initSliders(selector, settings) {
        const rowSliders = document.querySelectorAll(selector)
        const storedSettings = {}

        console.log('storedSettings', storedSettings)

        if (!rowSliders.length) {
            return
        }

        for (let i = 0; i < rowSliders.length; i++) {
            const sliderWrapper = rowSliders[i]
            const sliderElement = sliderWrapper.querySelector('.swiper')

            settings.navigation = this.getArrows(sliderWrapper)
            settings.pagination = this.getPagination(sliderWrapper)
            settings.autoplay = this.getAutoplayDuration(sliderWrapper)

            const swiper = new Swiper(sliderElement, settings)
        }
    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_swiper-slides.js